import { Link } from 'react-router';

import { useLanguage } from '../../contexts/language';

import styles from './style.module.css';

// A day's answers, one row each, in the order the record asks them. An answer
// that is not there reads "Skipped", never 0 or "None", because an empty
// answer stays empty.
//
// In the day card the rows are read-only; in the check-and-save step
// (editable) each row links to the step that asks it, so any answer can be
// changed before saving. With doses, each medication also says its dose, as
// a clinician reading the record needs it.
export function RecordRows({ day, editable, doses }) {
  const { text, language } = useLanguage();
  const number = new Intl.NumberFormat(language, { maximumFractionDigits: 1 });

  const level = function(value) {
    if (value == null) {
      return null;
    }

    return `${ value } · ${ text.levels[ value ] }`;
  };

  let mood = null;
  let swatch = null;

  if (day.mood != null) {
    mood = text.moods[ day.mood ].name;
    swatch = <span className={ styles.swatch } style={ { '--swatch': `var(--mood-${ day.mood })` } }></span>;
  }

  let sleep = null;

  if (day.sleepHours != null) {
    sleep = `${ number.format(day.sleepHours) } ${ text.hours }`;
  }

  let weight = null;

  if (day.weightKg != null) {
    weight = `${ number.format(day.weightKg) } ${ text.kg }`;
  }

  let medication = null;

  if (day.medicationEntries.length > 0) {
    medication = day.medicationEntries.map(function({ medication: { name, doseMg }, entry }) {
      if (doses === true && doseMg != null) {
        return `${ name } · ${ doseMg } mg: ${ entry }`;
      }

      return `${ name }: ${ entry }`;
    }).join(' · ');
  }

  const rows = [
    { step: 'mood', label: text.mood, value: mood, swatch },
    { step: 'anxiety', label: text.anxiety, value: level(day.anxiety) },
    { step: 'irritability', label: text.irritability, value: level(day.irritability) },
    { step: 'sleep', label: text.hoursSlept, value: sleep },
    { step: 'sleep', label: text.weight, value: weight },
    { step: 'medication', label: text.medication, value: medication }
  ].map(function({ step, label, value, swatch }) {
    let shown = <span className={ styles.skipped }>{ text.skipped }</span>;

    if (value != null) {
      shown = <span className={ styles.value }>{ swatch }{ value }</span>;
    }

    if (editable === true) {
      return (
        <Link key={ label } className={ `${ styles.row } ${ styles.link }` } to={ `/diary/record/${ day.date }/${ step }` }>
          <span className={ styles.label }>{ label }</span>

          { shown }
        </Link>
      );
    }

    return (
      <div key={ label } className={ styles.row }>
        <span className={ styles.label }>{ label }</span>

        { shown }
      </div>
    );
  });

  return <div className={ styles.rows }>{ rows }</div>;
}
